// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportItem__mPRIC {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--tables-primary-row-surface-default);
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
}

.reportItemBlock__hY5yc {
  min-height: 200px;
  padding: 25px;
}

.reportItemTitle__ZEPeP {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: var(--tables-primary-row-text-main);
  margin-top: 20px;
}

.reportItemDescription__jLNTf {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-secondary-row-sub-title-text);
  margin-top: 13px;
  margin-bottom: 0;
}

.reportItemDownload__KxwGf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  padding: 15px 25px;
  border-top: 1px solid var(--tables-primary-row-stroke);
}
.reportItemDownload__KxwGf svg path {
  stroke: var(--buttons-surface);
}

.reportItemToPage__Lxcy9 {
  display: flex;
  justify-content: space-between;
}

.reportItemDownloadInfo__dkhah {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-secondary-row-sub-title-text);
}

.reportItemDownloadInfoRtl__TbT0H {
  margin-right: 20px;
  margin-left: unset;
}

.arrowIconBack__jgftm {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./../src/pages/Reports/components/Report/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qDAAA;EACA,iDAAA;EACA,mDAAA;AAzEF;;AA4EA;EACE,iBAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,0CAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,gBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBAAA;EACA,sDAAA;AAzEF;AA4EI;EACE,8BAAA;AA1EN;;AA+EA;EACE,aAAA;EACA,8BAAA;AA5EF;;AA+EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;AA5EF;;AA+EA;EACE,kBAAA;EACA,kBAAA;AA5EF;;AA+EA;EACE,yBAAA;AA5EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.reportItem {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n}\n\n.reportItemBlock {\n  min-height: 200px;\n  padding: 25px;\n}\n\n.reportItemTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: 0.7px;\n  text-transform: uppercase;\n  color: var(--tables-primary-row-text-main);\n  margin-top: 20px;\n}\n\n.reportItemDescription {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-secondary-row-sub-title-text);\n  margin-top: 13px;\n  margin-bottom: 0;\n}\n\n.reportItemDownload {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n  padding: 15px 25px;\n  border-top: 1px solid var(--tables-primary-row-stroke);\n\n  svg {\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n}\n\n.reportItemToPage {\n  display: flex;\n  justify-content: space-between;\n}\n\n.reportItemDownloadInfo {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-secondary-row-sub-title-text);\n}\n\n.reportItemDownloadInfoRtl {\n  margin-right: 20px;\n  margin-left: unset;\n}\n\n.arrowIconBack {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reportItem": `reportItem__mPRIC`,
	"reportItemBlock": `reportItemBlock__hY5yc`,
	"reportItemTitle": `reportItemTitle__ZEPeP`,
	"reportItemDescription": `reportItemDescription__jLNTf`,
	"reportItemDownload": `reportItemDownload__KxwGf`,
	"reportItemToPage": `reportItemToPage__Lxcy9`,
	"reportItemDownloadInfo": `reportItemDownloadInfo__dkhah`,
	"reportItemDownloadInfoRtl": `reportItemDownloadInfoRtl__TbT0H`,
	"arrowIconBack": `arrowIconBack__jgftm`
};
module.exports = ___CSS_LOADER_EXPORT___;
